import React, { useState, useEffect } from 'react'
import { Col, Panel, Row } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import ButtonPanelWidget from '../../ButtonPanelWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import MiniProjectInfoListDurableArticles from '../../projectBasedItemsWidget/MiniProjectInfoListDurableArticles'
import ListDurableArticlesWidgetTable from '../listDurableArticlesWidget/ListDurableArticlesWidgetTable'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import notification from '../../../utils/notification'
import { SEARCH_ERR_MSG } from '../../../constants/msgText'
import { searchAssetRegisterWaittingApprove } from '../../../redux/actions/addDurableArticles'
import { cloneDeep } from 'lodash-es'

export default function ListDurableArticlesWidget(props) {
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()

  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)

  const handleSearch = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      // console.log('request : ', request)
      const response = await searchAssetRegisterWaittingApprove(request)
      // console.log('getLegalManagement ', response)

      let _schema = cloneDeep(formSchema)
      _schema.values = response.model || []
      setFormSchema(_schema)
    } catch (e) {
      console.log('error', e)
      notification.open('error', {
        title: e?.response?.data?.errors?.message || SEARCH_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  return (
    <>
      <Panel shaded collapsible defaultExpanded header={formSchema.header} bordered>
        <MiniProjectInfoListDurableArticles
          schema={formSchema?.searchForm}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          getValues={getValues}
          setValue={setValue}
          clearErrors={clearErrors}
          onSearch={handleSearch}
        />

        <ListDurableArticlesWidgetTable
          schema={formSchema}
          onReload={handleSearch}
          isViewMode={formSchema?.disabled}
        />
      </Panel>
      {isLoading && <OverlayLoader />}
    </>
  )
}
